import axios from "axios";
import { server } from "../api";

const toBoolean = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return ["1", "true", "yes", "y", "是"].includes(normalized);
  }
  return false;
};

const normalizePersonnelPayload = (record = {}) => {
  const payload = {};
  if (record.name !== undefined) payload.name = record.name;
  if (record.device_id !== undefined) payload.device_id = record.device_id;
  const onDutyValue =
    record.onDuty !== undefined ? record.onDuty : record.on_duty;
  if (onDutyValue !== undefined) {
    payload.onDuty = toBoolean(onDutyValue);
  }
  if (record.company !== undefined) payload.company = record.company;
  if (record.jobTitle !== undefined) payload.jobTitle = record.jobTitle;
  if (record.job_title !== undefined) payload.jobTitle = record.job_title;
  if (record.bloodType !== undefined) payload.bloodType = record.bloodType;
  if (record.blood_type !== undefined) payload.bloodType = record.blood_type;
  return payload;
};

const IndoorPositioningPersonnel = {
  GetPersonnel: async (machineID) => {
    try {
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}/personnel`,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "獲取室內定位人員失敗",
          data: [],
        }
      );
    }
  },

  CreatePersonnel: async (record) => {
    const machineID = record?.indoor_positioning_id;
    if (!machineID) {
      return { code: 400, message: "缺少室內定位機器 ID" };
    }

    const payload = normalizePersonnelPayload(record);
    try {
      const response = await axios.post(
        `${server}indoor-positioning/${machineID}/personnel`,
        payload,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "新增室內定位人員失敗",
        }
      );
    }
  },

  UpdatePersonnel: async (id, record, options = {}) => {
    const payload = normalizePersonnelPayload(record);
    try {
      const response = await axios.put(
        `${server}indoor-positioning/personnel/${id}`,
        payload,
        options,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "更新室內定位人員失敗",
        }
      );
    }
  },

  DeletePersonnel: async (id) => {
    try {
      const response = await axios.delete(
        `${server}indoor-positioning/personnel/${id}`,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "刪除室內定位人員失敗",
        }
      );
    }
  },

  BatchImportPersonnel: async (records, machineID) => {
    if (!machineID) {
      return { code: 400, message: "缺少室內定位機器 ID" };
    }
    const normalized = Array.isArray(records)
      ? records
          .filter((item) => item?.name && item?.device_id)
          .map((item) => {
            const payload = {
              name: item.name,
              device_id: item.device_id,
            };
            const onDutyValue =
              item?.onDuty !== undefined ? item.onDuty : item?.on_duty;
            if (onDutyValue !== undefined) {
              payload.onDuty = toBoolean(onDutyValue);
            }
            if (item.company !== undefined) payload.company = item.company;
            if (item.jobTitle !== undefined) payload.jobTitle = item.jobTitle;
            if (item.job_title !== undefined) payload.jobTitle = item.job_title;
            if (item.bloodType !== undefined)
              payload.bloodType = item.bloodType;
            if (item.blood_type !== undefined)
              payload.bloodType = item.blood_type;
            return payload;
          })
      : [];

    if (!normalized.length) {
      return { code: 400, message: "沒有有效的人員資料" };
    }

    try {
      const response = await axios.post(
        `${server}indoor-positioning/${machineID}/personnel/import`,
        {
          personnel: normalized,
        },
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "匯入室內定位人員失敗",
        }
      );
    }
  },
};

export default IndoorPositioningPersonnel;
